export enum CampaignType {
  Scheduled = 1,
  Recurring = 2,
  ExecuteNow = 3,
}

export enum CampaignFor {
  Sales = 1,
  Aftersales = 2,
}

export enum CampaignVia {
  Email = 1,
  SMS = 2,
  Both = 3,
}

export enum CampaignStatus {
  Draft = 1,
  InProgress = 2,
  Completed = 3,
}

export enum ExecutionFrequency {
  Daily = 1,
  Weekly = 2,
  Monthly = 3,
  Yearly = 4,
}

export enum CampaignStepType {
  Email = 1,
  SMS = 2,
  PushNotification = 3,
}

export enum WaitForCondition {
  MailSent = 1,
  MailOpened = 2,
  Clicked = 3,
}
